import React, { useState } from "react";
import { Button, Col, FormGroup, Modal, Row, Container } from "react-bootstrap";
import { Form, Input, Select, Radio } from 'antd';
import { Breadcrumb, ImageElement, LoginHeader } from "../../components";
import DatePicker from 'sassy-datepicker';
import { Link, } from "react-router-dom"
import TextArea from "antd/lib/input/TextArea";
import '../../../node_modules/sassy-datepicker/dist/styles.css';

const handleChange = (value) => {
    console.log(`selected ${value}`);
};


function ServiceDetail() {
    const [date, setDate] = useState(new Date());

    const onChange = newDate => {
        console.log(`New date selected - ${newDate.toString()}`);
        setDate(newDate);
    };

    const breadcrumb = [
        {
            path: '/dashboard',
            name: 'Home',
        },
        {
            path: '#',
            name: 'HVAC Services',
        },
    ];

    // modal
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [showbookdetail, setbookdetail] = useState(false);
    const bookdetailClose = () => setbookdetail(false);
    const bookdetailShow = () => {
        chooseBookingClose()
        setbookdetail(true);
    }

    const [emergency, setemergency] = useState(false);
    const emergencyClose = () => setemergency(false);
    const emergencyShow = () => setemergency(true);

    const [emergencyInfo, setemergencyInfo] = useState(false);
    const emergencyInfoClose = () => setemergencyInfo(false);
    const emergencyInfoShow = () => setemergencyInfo(true);

    const [emerbook, setemerbook] = useState(false);
    const emerbookClose = () => setemerbook(false);
    const emerbookShow = () => setemerbook(true);

    const [chooseBooking, setchooseBooking] = useState(false);
    const chooseBookingClose = () => setchooseBooking(false);
    const chooseBookingShow = () => {
        emergencyClose()
        setchooseBooking(true)
    };

    const [value, setValue] = useState(1);
    const onRadioChange = (e) => {
        setValue(e.target.value);
    };
    return (
        <>
            <LoginHeader />
            <div className="main-content dashboardPage serviceDetailPage">
                {/* page content */}
                <div className="pageContent">
                    <Container className="container-lg">
                        <Breadcrumb title="HVAC Services" breadcrumb={breadcrumb} />
                        {/* your address */}
                        <div className="yourAddress bg-white ">
                            <h2 className="font-sm">Let’s confirm your address</h2>
                            <p className="mb-0">Select and confirm your service address or add a new address</p>
                            <div className="d-flex align-items-center">
                                <Form className="w-100">
                                    <FormGroup className="form-group mb-0 d-flex align-items-center flex-wrap">
                                        <div className="position-relative yourAddress_form">
                                            <em className="gg-marker" />
                                            <Select
                                                defaultValue="address1"
                                                onChange={handleChange}
                                                className="w-100"
                                                options={[
                                                    {
                                                        value: 'address2',
                                                        label: 'Gita Bhawan',
                                                    },
                                                    {
                                                        value: 'address1',
                                                        label: 'Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India',
                                                    }
                                                ]}
                                            />
                                        </div>
                                        <Button variant="info" size="lg" type="submit" onClick={handleShow} className="ms-lg-4 ms-md-2  mt-md-0 mt-2 font-sm">Add location</Button>
                                    </FormGroup>
                                </Form>
                            </div>
                        </div>
                        {/* service address */}
                        <div className="serviceAddress bg-white mb-3">
                            <h2 className="font-sm mb-2">Service Address</h2>
                            <p className="mb-0 font-md">Vijay Nagar Square, Vijay Nagar, Indore, Madhya Pradesh, India</p>
                        </div>
                        {/* what your appointment */}
                        <div className="appointment bg-white mt-3 mb-4">
                            <div className="appointment_header d-flex justify-content-between align-items-xxl-start align-items-baseline flex-sm-row flex-column ">
                                <h2 className="font-sm appointment_title">What type of appointment?</h2>
                                <div className="yourAddress p-0 mt-sm-0 mt-2">
                                    <div className="d-flex align-items-center">
                                        {/* <Form className="w-100">
                                            <FormGroup className="form-group d-flex align-items-center mt-0 mb-md-3 mb-md-2">
                                            <div className="position-relative yourAddress_form">
                                                <span className="qty">Qty</span>
                                                <Select
                                                    defaultValue="value1"
                                                    onChange={handleChange}
                                                    className="w-100"
                                                    options={[
                                                        {
                                                        value: 'value1',
                                                        label: '1',
                                                        },
                                                        {
                                                        value: 'value2',
                                                        label: '2',
                                                        }
                                                    ]}
                                                    />
                                                </div>
                                            </FormGroup>
                                        </Form> */}
                                        <Link to="/dashboard" className="btn btn-outline-info mb-3">Back</Link>
                                    </div>
                                </div>
                            </div>
                            {/* EMPTY SCREEN_______ */}
                            {/* <div className="noList m-auto text-center d-flex align-items-center justify-content-center">
                                <div className="noList_inner">
                                    <ImageElement source="no-provider.svg" className="img-fluid"/>
                                    <div className="noList_cnt">
                                        <h5>No Booking Found</h5>
                                        <p className="mb-0">Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
                                    </div>
                                </div>                                
                            </div> */}
                            <Radio.Group onChange={onRadioChange} className="w-100 appointment_cover yourAddress" name="radiogroup" defaultValue={1}>
                                <div className="appointment_list border-top-0 d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="form-group my-0 me-3">
                                            <Radio value={1} checked></Radio>
                                        </FormGroup>
                                        <h3>Same day emergency service 1 <br /> (Paid- Emergency)</h3>
                                        <Link className="d-flex align-items-center" onClick={emergencyInfoShow} > <em className="gg-info" /> </Link>
                                    </div>
                                    <p className="mb-0 px-5">$99.95</p>
                                    <div className="appointment_fromgrp">
                                        {
                                            value === 1 ?
                                                <FormGroup className="form-group d-flex align-items-center mt-0 mb-0">
                                                    <div className="position-relative yourAddress_form">
                                                        <span className="qty">Qty</span>
                                                        <Select
                                                            defaultValue="value1"
                                                            onChange={handleChange}
                                                            className="w-100"
                                                            options={[
                                                                {
                                                                    value: 'value1',
                                                                    label: '1',
                                                                },
                                                                {
                                                                    value: 'value2',
                                                                    label: '2',
                                                                }
                                                            ]}
                                                        />
                                                    </div>
                                                </FormGroup> : ""
                                        }
                                    </div>
                                    <div className="appointment_btn">
                                        <button variant="info" size="lg" type="button" className="btn btn-primary" onClick={emerbookShow} disabled={value !== 1}> EMERGENCY BOOKING</button>
                                    </div>
                                </div>
                                <div className="appointment_list d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="form-group my-0 me-3">
                                            <Radio value={2} ></Radio>
                                        </FormGroup>
                                        <h3>Same day free emergency quote <br /> (Free- Emergency)</h3>
                                        <Link className="d-flex align-items-center" onClick={emergencyInfoShow} > <em className="gg-info" /> </Link>
                                    </div>
                                    <p className="mb-0 px-5">$99.95</p>
                                    <div className="appointment_fromgrp">
                                        {
                                            value === 2 ?
                                            <FormGroup className="form-group d-flex align-items-center mt-0 mb-0">
                                                <div className="position-relative yourAddress_form">
                                                    <span className="qty">Qty</span>
                                                    <Select
                                                        defaultValue="value1"
                                                        onChange={handleChange}
                                                        className="w-100"
                                                        options={[
                                                            {
                                                                value: 'value1',
                                                                label: '1',
                                                            },
                                                            {
                                                                value: 'value2',
                                                                label: '2',
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                            </FormGroup>: ""
                                        } 
                                    </div>
                                    <div className="appointment_btn">
                                        <button type="button" className="btn btn-primary" onClick={emerbookShow} disabled={value !== 2} > EMERGENCY BOOKING</button>
                                    </div>
                                </div>
                                <div className="appointment_list d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="form-group my-0 me-3">
                                            <Radio value={3}></Radio>
                                        </FormGroup>
                                        <h3>FL - Heating System Tuneup <br /> (Schedule)</h3>
                                        <Link className="d-flex align-items-center" onClick={emergencyInfoShow} > <em className="gg-info" /> </Link>
                                    </div>
                                    <p className="mb-0 px-5">$99.95</p>
                                    <div className="appointment_fromgrp">
                                        {
                                            value === 3 ?
                                            <FormGroup className="form-group d-flex align-items-center mt-0 mb-0">
                                                <div className="position-relative yourAddress_form">
                                                    <span className="qty">Qty</span>
                                                    <Select
                                                        defaultValue="value1"
                                                        onChange={handleChange}
                                                        className="w-100"
                                                        options={[
                                                            {
                                                                value: 'value1',
                                                                label: '1',
                                                            },
                                                            {
                                                                value: 'value2',
                                                                label: '2',
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                            </FormGroup>: ""
                                        } 
                                    </div>
                                    <div className="appointment_btn">
                                        <button variant="info" size="lg" type="button" className="btn btn-info" disabled={value !== 3} onClick={emergencyShow}> Schedule</button>
                                    </div>
                                </div>
                                <div className="appointment_list d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="form-group my-0 me-3">
                                            <Radio value={4}></Radio>
                                        </FormGroup>
                                        <h3>Install Store Bought Thermostat <br /> (Schedule)</h3>
                                        <Link className="d-flex align-items-center" onClick={emergencyInfoShow} > <em className="gg-info" /> </Link>
                                    </div>
                                    <p className="mb-0 px-5">$99.95</p>
                                    <div className="appointment_fromgrp">
                                        {
                                            value === 4 ?
                                            <FormGroup className="form-group d-flex align-items-center mt-0 mb-0">
                                                <div className="position-relative yourAddress_form">
                                                    <span className="qty">Qty</span>
                                                    <Select
                                                        defaultValue="value1"
                                                        onChange={handleChange}
                                                        className="w-100"
                                                        options={[
                                                            {
                                                                value: 'value1',
                                                                label: '1',
                                                            },
                                                            {
                                                                value: 'value2',
                                                                label: '2',
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                            </FormGroup>: ""
                                        } 
                                    </div>
                                    <div className="appointment_btn">
                                        <button type="button" className="btn btn-info" onClick={emergencyShow} disabled={value !== 4}> Schedule</button>
                                    </div>
                                </div>
                                <div className="appointment_list d-flex justify-content-between align-items-center">
                                    <div className="d-flex align-items-center">
                                        <FormGroup className="form-group my-0 me-3">
                                            <Radio value={5} ></Radio>
                                        </FormGroup>
                                        <h3>Indoor Air Quality Quote (Humidifier, Air Cleaner, Air Purifier. Etc.)<br /> (Free - Schedule)</h3>
                                        <Link className="d-flex align-items-center" onClick={emergencyInfoShow} > <em className="gg-info" /> </Link>
                                    </div>
                                    <p className="mb-0 px-5">$99.95</p>
                                    <div className="appointment_fromgrp">
                                        {
                                            value === 5 ?
                                            <FormGroup className="form-group d-flex align-items-center mt-0 mb-0">
                                                <div className="position-relative yourAddress_form">
                                                    <span className="qty">Qty</span>
                                                    <Select
                                                        defaultValue="value1"
                                                        onChange={handleChange}
                                                        className="w-100"
                                                        options={[
                                                            {
                                                                value: 'value1',
                                                                label: '1',
                                                            },
                                                            {
                                                                value: 'value2',
                                                                label: '2',
                                                            }
                                                        ]}
                                                    />
                                                </div>
                                            </FormGroup>: ""
                                        } 
                                    </div>
                                    <div className="appointment_btn">
                                        <button type="button" className="btn btn-info" onClick={emergencyShow} disabled={value !== 5}> Schedule</button>
                                    </div>
                                </div>
                                
                            </Radio.Group>
                        </div>
                    </Container>
                </div>
            </div>
            {/* Paid- Emergency */}
            <Modal show={emergency} onHide={emergencyClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Same day emergency service 1 (Paid- Emergency)</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Having a problem and want it fixed today? This is the right option!</p>
                        <p> Please note - After completing your booking. Give us a moment to connect you with a technician closest to your home. Once a technician is able to step away from their current customer, he will contact you directly to confirm the appointment for same-day repair.</p>
                        <p> *If you have a Home Warranty & choose this option, the home warranty company WILL NOT cover the additional charge. You are agreeing to pay the additional service fee.</p>
                    </div>
                    <div className="d-flex justify-content-end">
                        {/* <Link to="/book-appointment" variant="primary" className="btn btn-primary min-200">Continue</Link> */}
                        <button variant="primary" className="btn btn-primary min-200" onClick={() => chooseBookingShow()} >Continue</button>
                    </div>
                </Modal.Body>
            </Modal>


            {/* Paid- Emergency without continue btn */}
            <Modal show={emergencyInfo} onHide={emergencyInfoClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Same day emergency service 1 (Paid- Emergency)</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Having a problem and want it fixed today? This is the right option!</p>
                        <p> Please note - After completing your booking. Give us a moment to connect you with a technician closest to your home. Once a technician is able to step away from their current customer, he will contact you directly to confirm the appointment for same-day repair.</p>
                        <p> *If you have a Home Warranty & choose this option, the home warranty company WILL NOT cover the additional charge. You are agreeing to pay the additional service fee.</p>
                    </div>
                </Modal.Body>
            </Modal>

            {/* add location */}
            <Modal show={show} onHide={handleClose} size="lg" centered id="addLocation" className="addLocation" backdrop="static">
                <Modal.Header closeButton className="align-items-start pb-0">
                    <div>
                        <Modal.Title>Add Location</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h6 className="subTitle">Service Address</h6>
                        <FormGroup className="form-group">
                            <label className="ant-label">Address Line 1 <span className="text-650">*</span></label>
                            <Input size="large" placeholder="Address Line 1" required />
                        </FormGroup>
                        <Row>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Name</label>
                                    <Input size="large" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Address Line 2</label>
                                    <Input size="large" />
                                </FormGroup>
                                {/* <FormGroup className="form-group">
                                <Input size="large" placeholder="Last Name*" />
                                <label className="ant-label">Last Name<span className="text-650">*</span></label>
                            </FormGroup> */}
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">Suite Number</label>
                                    <Input size="large" />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group">
                                    <label className="ant-label">State<span className="text-650">*</span></label>
                                    <Input size="large" required />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group mb-3 mb-sm-0">
                                    <label className="ant-label">City<span className="text-650">*</span></label>
                                    <Input size="large" required />
                                </FormGroup>
                            </Col>
                            <Col sm={6}>
                                <FormGroup className="form-group mb-0">
                                    <label className="ant-label">Zip Code</label>
                                    <Input size="large" />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Button variant="primary" className="mt-3 mt-sm-4 ms-auto min-200 btn btn-primary" onClick={handleClose}>Save</Button>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* choosebooking*/}
            <Modal show={chooseBooking} onHide={chooseBookingClose} size="xl" centered id="chooseBookingmodal" className="chooseBookingmodal" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Choose Booking Date & Time</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="chooseBookingmodal">
                        <Row>
                            <Col lg={6} sm={12}>
                                <div className="selectDate">
                                    <h3 className="selectDate_heading">Select Date</h3>
                                    <div className="selectDate_content">
                                        <DatePicker onChange={onChange} value={date} />
                                    </div>
                                </div>
                            </Col>
                            <Col lg={6} sm={12}>
                                <div className="selectTime mt-lg-0 mt-3 d-flex flex-column selectHeight justify-content-between">
                                    <h3 className="selectDate_heading">Select Time</h3>
                                    <div className="d-flex flex-column selectHeight justify-content-between">
                                        <div className="selectTime_content">
                                            <Row>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one" name="one" value="one" disabled={true} />
                                                        <label htmlFor="one"> 5:00 AM – 7:00 AM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one2" name="one2" value="one2" />
                                                        <label htmlFor="one2"> 7:00 AM – 9:00 AM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one3" name="one3" value="one3" />
                                                        <label htmlFor="one3"> 8:00 AM – 11:00 AM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one4" name="one4" value="one4" />
                                                        <label htmlFor="one4"> 11:00 AM – 2:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one5" name="one5" value="one5" disabled={true} />
                                                        <label htmlFor="one5"> 2:00 PM – 5:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one6" name="one6" value="one6" disabled={true} />
                                                        <label htmlFor="one6"> 2:00 PM – 5:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one7" name="one7" value="one7" />
                                                        <label htmlFor="one7"> 5:00 AM – 7:00 AM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one8" name="one8" value="one8" />
                                                        <label htmlFor="one8"> 8:00 PM – 11:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one9" name="one9" value="one9" />
                                                        <label htmlFor="one9">8:00 PM – 11:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one10" name="one10" value="one10" />
                                                        <label htmlFor="one10"> 5:00 AM – 7:00 AM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one11" name="one11" value="one11" />
                                                        <label htmlFor="one11"> 8:00 PM – 11:00 PM</label>
                                                    </div>
                                                </Col>
                                                <Col xl={4} xs={6}>
                                                    <div className="slot">
                                                        <input type="checkbox" id="one12" name="one12" value="one12" />
                                                        <label htmlFor="one12"> 8:00 PM – 11:00 PM</label>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                        <div className="d-flex justify-content-end align-items-end chooseBookingmodal_button">
                                            {/* <Button  className="btn btn-light" onClick={chooseBookingClose}>CANCEL</Button> */}
                                            <Link className="btn btn-primary ms-3" onClick={() => bookdetailShow()}>CONTINUE</Link>
                                        </div>
                                    </div>
                                </div>

                            </Col>
                        </Row>
                    </div>

                </Modal.Body>
            </Modal>

            {/* emergency booking */}
            <Modal show={emerbook} onHide={emerbookClose} size="lg" centered id="paidEmergency" className="paidEmergencymodel" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Same day emergency service 1 (Paid- Emergency)</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="paidEmergency">
                        <p> Having a problem and want it fixed today? This is the right option!</p>
                        <p> Please note - After completing your booking. Give us a moment to connect you with a technician closest to your home. Once a technician is able to step away from their current customer, he will contact you directly to confirm the appointment for same-day repair.</p>
                        <p> *If you have a Home Warranty & choose this option, the home warranty company WILL NOT cover the additional charge. You are agreeing to pay the additional service fee.</p>
                    </div>
                    <div className="d-flex justify-content-end">
                        <Link to="/book-appointment" className="btn btn-primary min-200">Continue</Link>
                    </div>
                </Modal.Body>
            </Modal>

            {/* booking details */}
            <Modal show={showbookdetail} onHide={bookdetailClose} size="lg" centered id="addLocation" className="bookingDetails" backdrop="static">
                <Modal.Header closeButton className="align-items-start">
                    <div>
                        <Modal.Title>Booking Details</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <Row className="align-items-center">
                            <Col lg={12} sm={12}>
                                <ul className="bookingDetails list-unstyled mb-0">
                                    <li className="bookingDetails_list d-flex">
                                        <label>Paid Schedule <span>X 1</span></label>
                                        <span className="font-sm">$100</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Provider</label>
                                        <span className="font-sm">James John</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Company Name</label>
                                        <span className="font-sm">Versatile Sash & Woodwork</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Date</label>
                                        <span className="font-sm">Jan 25,2023</span>
                                    </li>
                                    <li className="bookingDetails_list d-flex">
                                        <label>Booking Time</label>
                                        <span className="font-sm">11:00 AM - 02:00 PM</span>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                        <div className="promoCode">
                            <Form className="d-flex align-items-end">
                                <FormGroup className="form-group promoCode_wrapper mb-0">
                                    <label className="ant-label font-md">Promo Code</label>
                                    <Input size="large" placeholder="Promo Code" value="NIT" />
                                </FormGroup>
                                <Button variant="primary" type="submit" className="ms-2 font-sm d-inline-block">APPLY</Button>
                            </Form>
                            <div className="promoCode_info mt-2 d-flex align-items-center"><em className="gg-check-circle me-2" /> <span>Promo Code applied!</span></div>
                        </div>
                        <div className="mb-3">
                            <ul className="serviceCost list-unstyled mt-lg-0 mt-3 mb-0">
                                <li className="serviceCost_list">
                                    <label>Total Cost</label>
                                    <span className="font-sm">$98.98</span>
                                </li>
                            </ul>
                        </div>
                        <FormGroup className="form-group">
                            <label className="ant-label font-md ps-0">Add Special Instruction For Provider Below</label>
                            <TextArea rows={5} />
                        </FormGroup>
                        <div className="d-flex justify-content-end">
                            <Link to="/service-provider-list" className="ms-auto min-200 mt-lg-4 mt-3 btn btn-primary" onClick={() => bookdetailClose()}>Booking Now</Link>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ServiceDetail;